import * as angular from 'angular';

import { ValidationPageConfiguration } from '../../models';
import { IValidationPageConfigurationActionsService } from './validationPageConfigurations.actionCreator';
import { IDispatcherService, IDispatcher } from '../';
import { IWidget } from '../../widgets';

export interface IValidationPageConfigurationStoreService {
    getOne: (guid: string) => angular.IPromise<ValidationPageConfiguration>;
    getAll: (force?: boolean) => angular.IPromise<ValidationPageConfiguration[]>;
    updateReferenceGroup: (groupType: string, referenceGroupGuid: string, widgets: IWidget[]) => angular.IPromise<ValidationPageConfiguration[]>;
}

export interface IValidationPageConfigurationActionDispatcherService extends IDispatcherService<IValidationPageConfigurationStoreService> { }

export class ValidationPageConfigurationActionDispatcherService implements IValidationPageConfigurationActionDispatcherService {
    static serviceId = 'validationPageConfigurationActionDispatcherService';

    static $inject = ['validationPageConfigurationActionsService'];

    constructor(private _actionService: IValidationPageConfigurationActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IValidationPageConfigurationStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getOne: (guid: string) => dispatch(actionService.getOne(guid)),
                getAll: (force?: boolean) => dispatch(actionService.getAll(force)),
                updateReferenceGroup: (groupType: string, referenceGroupGuid: string, widgets: IWidget[]) => dispatch(actionService.updateReferenceGroup(groupType, referenceGroupGuid, widgets))
            }
        };
    }
}